import { render, staticRenderFns } from "./Summery.vue?vue&type=template&id=7206870e&scoped=true&"
import script from "./Summery.vue?vue&type=script&lang=js&"
export * from "./Summery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206870e",
  null
  
)

export default component.exports